import { useRef, useCallback, useEffect } from 'react'

/**
 * Wrap the setTiemout function in a hook
 *
 * @param {Function} callback the function to execute after the timeout
 * @param {number} interval the timeout in ms
 * @param {boolean} lazy Run the returned execute method to invoke the timeout
 */
export function useTimeout<TLazy extends boolean>(callback: () => void, interval: number, lazy?: TLazy) {
	const savedTimeout = useRef<number>()

	const execute = useCallback(() => {
		savedTimeout.current = setTimeout(callback, interval) as unknown as number
	}, [callback, interval])

	const cancel = useCallback(() => clearTimeout(savedTimeout.current), [])

	useEffect(() => {
		if (!lazy) {
			execute()
		}

		return () => cancel()
	}, [callback, interval, cancel])

	return { cancel, ...(lazy ? { execute } : {}) } as TLazy extends true
		? { cancel: () => void; execute: () => void }
		: { cancel: () => void }
}
